import React, {Component} from 'react';
import {config, DISPATCH_ID} from '../libs/utils/Const';
import {connect} from "react-redux";

class NavBarContentSearchItems extends Component {

    constructor(props) {
        super(props);
        this.state = {
            typeSearch : '0',
            seller: JSON.parse(localStorage.getItem(config.general.localStorageNamed + 'PartnerUser')),
        };
    };

    search = async () => {
        const {itemsReducer,setIdCategory,setLocation,setTypeSearch} = this.props;
        const {typeSearch} = this.state;
        setIdCategory(null);
        setLocation('navBar');
        setTypeSearch(typeSearch)
        await itemsReducer.searchByKey(0,typeSearch);
    };

    changeSearch = (event) => {
        this.setState({
            typeSearch: event.nativeEvent.target.value,
        })
    };

    render() {
        const {itemsReducer, setSearch, icon, iconColor, textColor} = this.props;
        const {seller} = this.state;
        // console.log('con<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<',);
        // console.log('con<seller:',seller ? seller.U_FMB_Handel_Perfil : 'NADA');
        return (
            <div className="input-group" style={{paddingTop:10}}>
                <input
                    type="text"
                    className="form-control text-left"
                    name="password"
                    placeholder="Buscar producto"
                    autoComplete={'off'}
                    style={{textAlign: 'center', height: 30}}
                    onKeyDown={event => event.keyCode === 13 && this.search()}
                    value={itemsReducer.search}
                    onChange={(event) => setSearch(event.target.value)}

                />
                {seller ? seller.U_FMB_Handel_Perfil === 1 ? 
                    <select id="Selectactiva" class="" style={{backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000', width:'20px'}} onChange={(event) => this.changeSearch(event)}>
                        <option value='0'>Producto terminado</option>
                        <option value='1'>Artículos de marketing</option>
                        <option value='2'>Todos los artículos</option>
                    </select>
                    : "" : ""
                }
                <div className="input-group-prepend" onClick={this.search} style={{marginLeft: 5}}>
                            <span
                                className="input-group-text"
                                style={{
                                    textAlign: 'center',
                                    height: 30,
                                    cursor: 'pointer',
                                    border: 'none',
                                    background: 'none',
                                }}>
                                <i                                    
                                    className={icon + "d-sm-none"}
                                    style={{marginLeft: 5, cursor: 'pointer', color: iconColor }}
                                    aria-hidden="true"
                                />
                            </span>
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return {
        itemsReducer: store.ItemsReducer,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setSearch: value => dispatch({type: DISPATCH_ID.ITEMS_SET_SEARCH, value}),
        setIdCategory: value => dispatch({type: DISPATCH_ID.ITEMS_SET_IDCATEGORY, value}),
        setNextPage:  value => dispatch({type: DISPATCH_ID.ITEMS_SET_NEXTPAGE, value}),
        setLocation:  value => dispatch({type: DISPATCH_ID.ITEMS_SET_LOCATION, value}),
        setTypeSearch:  value => dispatch({type: DISPATCH_ID.ITEMS_SET_TYPESEARCH, value}),        
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NavBarContentSearchItems)
